export const heightMix = (height: string) => `
    height: ${height};
`;

export const widthMix = (width: string) => `
    width: ${width};
`;

export const marginMix = (margin: string) => `
    margin: ${margin};
`;

export const paddingMix = (padding: string) => `
    padding: ${padding};
`;
